import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setMCQContext } from "../utils/mcqContext";

const Profile = () => {

  const navigate = useNavigate();

  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [tiles, setTiles] = useState([]);

  const BASE_URL = "https://edunet.kmechengineering.com/root-engine1/public/images/";

  // resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // navbar hide / top show only
  useEffect(() => {
    const navbar = document.querySelector(".navbar");

    const handleScroll = () => {
      const currentScroll = window.pageYOffset;

      if (!navbar) return;

      if (currentScroll <= 10) {
        navbar.style.transform = "translateX(-50%) translateY(0)";
        navbar.style.opacity = "1";
      } else {
        navbar.style.transform = "translateX(-50%) translateY(-130%)";
        navbar.style.opacity = "0";
      }
    };

    if (navbar) {
      navbar.style.position = "fixed";
      navbar.style.top = "15px";
      navbar.style.left = "50%";
      navbar.style.width = "90%";
      navbar.style.maxWidth = "1100px";
      navbar.style.transform = "translateX(-50%)";
      navbar.style.zIndex = "9999";
      navbar.style.transition = "all 0.35s ease";
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);

      if (navbar) {
        navbar.style.transform = "translateX(-50%) translateY(0)";
        navbar.style.opacity = "1";
      }
    };
  }, []);

  // load user
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (!storedUser) {
      navigate("/auth");
      return;
    }

    setUser({
      ...storedUser,
      picture: storedUser.picture || storedUser.image || ""
    });

    setLoading(false);
  }, [navigate]);

  // fetch latest profile
  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));

    if (storedUser?.email) {
      fetch("https://edunet.kmechengineering.com/root-engine1/api/profile?email=" + storedUser.email)
        .then(res => res.json())
        .then(data => {
          if (data.user) {
            setUser(prev => ({
              ...prev,
              ...data.user,
              picture: data.user.image
            }));
          }
        });
    }
  }, []);

  // fetch dashboard items
  useEffect(() => {
    fetch("https://edunet.kmechengineering.com/root-engine1/api/dashboard-items")
      .then(res => res.json())
      .then(data => setTiles(data));
  }, []);

  if (loading) return null;
  if (!user) return null;

  return (
    <div style={styles.container}>
      <div style={styles.wrapper}>

        <div
          style={{
            ...styles.tileContainer,
            gridTemplateColumns: isMobile
              ? "repeat(2,1fr)"
              : "repeat(auto-fit,minmax(220px,1fr))"
          }}
        >

          {tiles.map((item) => {

            // PROFILE TILE
            if (item.type === "profile") {
              return (
                <div key={item.id} style={styles.tile} onClick={() => navigate(item.route)}>
                  {user.picture ? (
                    <img
                      src={`${user.picture}?t=${Date.now()}`}
                      style={styles.profileTileImg}
                    />
                  ) : (
                    <div style={styles.profileTileAvatar}>
                      {user.name?.charAt(0)}
                    </div>
                  )}
                  <span style={styles.tileText}>{item.title}</span>
                </div>
              );
            }

            // NORMAL TILE
            return (
              <div
                key={item.id}
                style={{
                  ...styles.tile,
                  background: item.color,
                  ...(item.size === "big" ? { gridColumn: "span 2" } : {})
                }}

                 onClick={() => {

                   console.log("CLICKED =", item.title);

                   if (item.title === "Paid MCQ") {

                     localStorage.setItem("flow_type", "mcq");

                     setMCQContext({
                       type: "paid"
                     });

                     navigate(`/mcq/grade/${localStorage.getItem("selected_grade")}`);
                     return;
                   }

                   if (item.title === "Essay Paid") {

                     localStorage.setItem("flow_type", "essay");

                     setMCQContext({
                       type: "paid"
                     });

                     navigate(`/essay/grade/${localStorage.getItem("selected_grade")}`);
                     return;
                   }

                   if (item.title === "MCQ") {

                     localStorage.setItem("flow_type", "mcq");

                     setMCQContext({
                       type: "free"
                     });

                     navigate(item.route);

                     return;
                   }

                   if (item.title === "Essay") {

                     localStorage.setItem("flow_type", "essay");

                     setMCQContext({
                       type: "free"
                     });

                     navigate("/mcq", {
                       state: {
                         type: "essay"
                       }
                     });

                     return;
                   }

                   navigate(item.route);

                 }}


              >
                <img
                  src={BASE_URL + item.image}
                  style={item.size === "big" ? styles.iconBig : styles.iconSmall}
                  alt={item.title}
                />

                <span style={styles.tileText}>{item.title}</span>
              </div>
            );
          })}

        </div>

      </div>
    </div>
  );
};

export default Profile;


// ================= STYLES =================

const styles = {
  container: { background: "#0f172a", minHeight: "100vh" },

  wrapper: { padding: "20px" },

  tileContainer: {
    display: "grid",
    gridAutoRows: "160px",
    gap: "15px"
  },

  tile: {
    background: "#f1c40f",
    color: "#fff",
    borderRadius: "10px",
    padding: "15px",
    position: "relative",
    cursor: "pointer"
  },

  tileText: {
    position: "absolute",
    bottom: "12px",
    left: "14px"
  },

  iconBig: {
    width: "50px",
    height: "50px",
    position: "absolute",
    top: "20px",
    left: "20px"
  },

  iconSmall: {
    width: "30px",
    height: "30px",
    position: "absolute",
    top: "20px",
    left: "20px"
  },

  profileTileImg: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    position: "absolute",
    top: "20px",
    left: "20px"
  },

  profileTileAvatar: {
    width: "50px",
    height: "50px",
    borderRadius: "50%",
    background: "#065f46",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "20px",
    left: "20px"
  }
};